import styled from "styled-components";
import { Switch } from "@blueprintjs/core";

export const ConfigSetting = styled.div`
  margin: var(--global-spacing-xs);
`;

export const SwitchDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledSwitch = styled(Switch)`
  display: inline-block;
  vertical-align: top;
`;

export const SwitchDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchTitle = styled.div`
  font-size: var(--global-font-size-s);
  line-height: var(--global-font-size-xl);
`;

export const SwitchSubtitle = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: var(--global-font-size-xs);
`;

export const codeBlockStyle = {
  minHeight: "400px",
};

export const CodeBlock = styled.section`
  display: flex;
  gap: var(--global-spacing-m);
`;
